(function () {
  const countryUrlMap = {
    us: {origin: "https://us.aqara.com", pathname: "/"},
    ca: {origin: "https://us.aqara.com", pathname: "/en-ca"},
    gb: {origin: "https://eu.aqara.com", pathname: "/"},
    de: {origin: "https://eu.aqara.com", pathname: "/de-eu"},
    fr: {origin: "https://eu.aqara.com", pathname: "/fr-eu"},
    es: {origin: "https://eu.aqara.com", pathname: "/es-eu"},
    it: {origin: "https://eu.aqara.com", pathname: "/it-eu"},
  };

  function setCookie(name, value, hours) {
    const date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    const { hostname } = window.location;
    const domain = hostname.includes("test") ? "" : "domain=.aqara.com;";
    const path = "path=/";
    document.cookie = name + "=" + value + ";" + expires + ";" + domain + path;
  }
  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function getCountry() {
    return fetch("https://get.geojs.io/v1/ip/geo.json")
      .then((response) => response.json())
      .then((data) => {
        return data.country_code.toLowerCase();
      })
      .catch((error) => {
        console.error("Error fetching country code:", error);
        return "gb"; // Default to United kingdom if there's an error
      });
  }

  function addChangeSiteDom(countryCode) {

    if (document.getElementById("change-site-dom")) {
      return;
    }

    const changeSiteDom = document.createElement("div");
    changeSiteDom.id = "change-site-dom";
    changeSiteDom.classList.add("header__wrapper");

    const textNode = document.createTextNode("Select another country or region to get content and online shopping options that apply to your location");
    changeSiteDom.appendChild(textNode);

    const select = addSimulateSelect(countryCode);
    changeSiteDom.appendChild(select);

    const button = addChangeSiteButton();
    changeSiteDom.appendChild(button);

    const closeIcon = addCloseIcon();
    changeSiteDom.appendChild(closeIcon);

    const headerItem = document.querySelector(".shopify-section-group-group-header");
    headerItem.parentNode.insertBefore(changeSiteDom, headerItem);
  }

  function addSimulateSelect(countryCode) {
    const simulateSelect = document.createElement("div");
    simulateSelect.id = "change-site-simulate-select";

    const options = [
      { value: "us", text: "United States" },
      { value: "ca", text: "Canada" },
      { value: "gb", text: "United Kingdom" },
      { value: "fr", text: "France" },
      { value: "de", text: "Germany" },
      { value: "es", text: "Spain" },
      { value: "it", text: "Italy" },
    ];

    const curSelectShow = document.createElement("p");
    curSelectShow.id = "change-site-simulate-text";

    const selectText = document.createElement("span");
    selectText.id = "change-site-simulate-span";
    selectText.textContent = options.find((option) => option.value === countryCode)?.text || "United Kingdom";
    selectText.dataset.value = options.find((option) => option.value === countryCode)?.value || "gb";;
    curSelectShow.appendChild(selectText);

    const selectIcon = document.createElementNS('http://www.w3.org/2000/svg', "svg");
    selectIcon.id = "change-site-simulate-icon";
    selectIcon.setAttribute("viewBox", "0 0 24 24");
    selectIcon.setAttribute("width", "24");
    selectIcon.setAttribute("height", "24");
    selectIcon.innerHTML = `<path d="M6 9l6 6 6-6" />`;
    curSelectShow.appendChild(selectIcon);

    simulateSelect.appendChild(curSelectShow);

    const optionUl = document.createElement("ul");
    optionUl.id = "change-site-simulate-option";
    options.forEach((option) => {
      const opt = document.createElement("li");
      opt.textContent = option.text;
      opt.dataset.value = option.value;
      if (option.value === countryCode) {
        opt.classList.add("selected");
      }
      optionUl.appendChild(opt);
    });
    optionUl.addEventListener("click", (event) => {
      const selectedOption = event.target;
      if (selectedOption.tagName === "LI") {
        selectText.textContent = selectedOption.textContent;
        selectText.dataset.value = selectedOption.dataset.value;
        optionUl.querySelectorAll("li").forEach((li) => {
          if (li !== selectedOption) {
            li.classList.remove("selected");
          }
        });
        selectedOption.classList.add("selected");
      }
    });
    simulateSelect.appendChild(optionUl);

    simulateSelect.addEventListener("click", () => {
      const ul = simulateSelect.querySelector("ul");
      if (ul.style.display === "none" || ul.style.display === "") {
        ul.style.display = "block";
        selectIcon.innerHTML = `<path d="M6 15l6-6 6 6" />`;
      } else {
        ul.style.display = "none";
        selectIcon.innerHTML = `<path d="M6 9l6 6 6-6" />`;
      }
    });
    document.addEventListener("click", (event) => {
      const simulateSelect = document.getElementById("change-site-simulate-select");
      if (simulateSelect && !simulateSelect.contains(event.target)) {
        const ul = simulateSelect.querySelector("ul");
        if (ul) {
          ul.style.display = "none";
          selectIcon.innerHTML = `<path d="M6 9l6 6 6-6" />`;
        }
      }
    });

    return simulateSelect;
  }

  function addChangeSiteButton() {
    const button = document.createElement("button");
    button.id = "change-site-confirm-button";
    button.textContent = "Select";

    button.addEventListener("click", () => {
      const selectedCountryCode = document.getElementById("change-site-simulate-span").dataset.value;
      console.log("Selected country code:", selectedCountryCode);
      const curTime = new Date().getTime();
      setCookie("closeChangeSiteTime", curTime, 24);
      let href = `${countryUrlMap[selectedCountryCode].origin}${countryUrlMap[selectedCountryCode].pathname}`;
      window.location.href = href;
    });
    return button;
  }

  function addCloseIcon() {
    const closeIcon = document.createElement("span");
    closeIcon.id = "change-site-close-icon";
    closeIcon.textContent = "×";
    closeIcon.addEventListener("click", () => {
      const changeSiteDom = document.getElementById("change-site-dom");
      if (!changeSiteDom) {
        return;
      }
      document.body.removeChild(changeSiteDom);
      const curTime = new Date().getTime();
      setCookie("closeChangeSiteTime", curTime, 24);
    });
    return closeIcon;
  }

  getCountry().then((countryCode) => {
    let {href} = window.location;
    if (countryUrlMap[countryCode]) {
      href = `${countryUrlMap[countryCode].origin}${countryUrlMap[countryCode].pathname}`;
    }
    if (window.location.href.includes(href)) {
      return;
    }
    const closeChangeSiteTime = getCookie("closeChangeSiteTime");
    if (closeChangeSiteTime) {
      return;
    }
    addChangeSiteDom(countryCode);
  })
})();
  